import { useCallback, useEffect, useState } from 'react';
import { generarTransaccionPowerpay, obtenerEstadoBotonPowerpay, verificarExistenciaTransaccion } from '../../helpers';

export const useVerificarGenerarTransaccion = (jwt, idOrden, studentCode, pagar) => {

  const [state, setState] = useState({
    transaccionId:"",
    urlPowerpay: "",
    expiredPowerpay: false,
    isLoading: false,
    hasError: null,
    mostrarPowerpay: false,
    montoMinimoPp: 0,
    montoMaximoPp: 0
  });  

  const getAxios = async () => {
    setState({
      ...state,
      isLoading: true,
    });

    const authPayment = {
      headers: {  
        Authorization: "Bearer " + jwt,
      },
    };
        
    const {transaccionId, mensajeError, urlPowerpay, statusPowerpay} = await verificarExistenciaTransaccion(idOrden, authPayment);  

    if(mensajeError.length > 0){
      setState({
        ...state,
        transaccionId: "",
        urlPowerpay: "",
        expiredPowerpay:false,
        isLoading:false,
        hasError: !!mensajeError
      });
    }
    else if(statusPowerpay === "EXPIRED"){
      setState({
        ...state,
        transaccionId,
        urlPowerpay: "",
        expiredPowerpay:true,
        isLoading:false,
        hasError: !!mensajeError
      });
    }
    else if(transaccionId.length < 1 )
    {      
      const {transaccionId, mensajeError, urlPowerpay} = await generarTransaccionPowerpay(idOrden, studentCode, authPayment);  

      if(mensajeError.length > 0){
        alert(mensajeError)
      }
      setState({
        ...state,
        transaccionId,
        urlPowerpay,
        expiredPowerpay:false,
        isLoading:false,
        hasError: !!mensajeError      
      });
    } else {
      setState({
        ...state,
        transaccionId,
        urlPowerpay,
        expiredPowerpay:false,
        isLoading: false,
        hasError: !!mensajeError      
      });
    }
  }

  const getMostrarPowerpay = async () => {
    setState({
      ...state,
      isLoading: true,
    });

    const { estadoPowerpay, montoMinimoPp, montoMaximoPp, mensajeError } = await obtenerEstadoBotonPowerpay();
    if(mensajeError.length > 0){
      alert(mensajeError)
    }
    setState({
      ...state,
      mostrarPowerpay: estadoPowerpay,
      montoMinimoPp,
      montoMaximoPp,
      isLoading:false,
      hasError: !!mensajeError      
    });

  }

  const verificarMostrarBotonPowerpay = useCallback(getMostrarPowerpay, [idOrden]);

  const verificarObtenerPago = useCallback(getAxios, [jwt, idOrden, studentCode]);
  
  useEffect(() => {
      verificarMostrarBotonPowerpay();
  }, [verificarMostrarBotonPowerpay])


  useEffect(() => {
    if(pagar) {
      verificarObtenerPago()
    }
  }, [pagar, verificarObtenerPago])
  
  return {
    transaccionId: state.transaccionId, 
    urlPowerpay: state.urlPowerpay,
    statusPowerpay: state.statusPowerpay,
    isLoading: state.isLoading, 
    hasError: state.hasError,
    mostrarPowerpay: state.mostrarPowerpay,
    montoMinimoPp: state.montoMinimoPp,
    montoMaximoPp: state.montoMaximoPp
  }
}